// src/components/ads-admin/Stepper.jsx
import React from "react";

export default function Stepper({ step, setStep, maxStepAllowed, onBlocked }) {
  const steps = [
    { k: 1, t: "Brand & Source" },
    { k: 2, t: "Accounts" },
    { k: 3, t: "Fetch Ads" },
    { k: 4, t: "Browse Ads" },
  ];

  return (
    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginTop: 10 }}>
      {steps.map((s, idx) => {
        const active = s.k === step;
        const done = s.k < step;
        const locked = s.k > maxStepAllowed;

        return (
          <button
            key={s.k}
            onClick={() => {
              if (locked) return onBlocked?.(s.k);
              setStep(s.k);
            }}
            className={active ? "btn-primary" : "btn-secondary"}
            disabled={locked}
            style={{
              padding: "10px 14px",
              borderRadius: 999,
              display: "inline-flex",
              gap: 10,
              alignItems: "center",
              opacity: locked ? 0.45 : 1,
              cursor: locked ? "not-allowed" : "pointer",
            }}
            title={locked ? "Locked by quality gates" : done ? "Done (click to revisit)" : active ? "Current step" : "Go to step"}
          >
            <span style={{ fontWeight: 900 }}>{done ? "✓" : idx + 1}</span>
            <span style={{ fontWeight: 900 }}>{s.t}</span>
            {locked && <span style={{ fontWeight: 950, opacity: 0.8 }}>🔒</span>}
          </button>
        );
      })}
    </div>
  );
}